import {
    allFetch,
} from "../Domain";

/**
 * @description 鈑烤工單
 */
export const PanelPaintOrder = (() => {

    /**
     * 新增鈑烤工單
     * @param {*} wom_id 工單流水號
     * @param {*} pppl_id 金額等級流水號
     * @param {*} ppsl_big 狀態大標籤流水號
     * @param {*} ppsl_mid 狀態中標籤流水號
     * @param {*} ppsl_small 狀態小標籤流水號
     * @param {*} predict_complete_time 預計完工時間
     * @param {*} note 備註
     * @returns 
     */
    const PanelPaintOrderCreate = async function (obj = {
        wom_id: '',
        pppl_id: '',
        ppsl_big: '',
        ppsl_mid: '',
        ppsl_small: '',
        predict_complete_time: '',
        note: ''
    }) {
        return await allFetch('PanelPaintOrder/PanelPaintOrderCreate', obj);
    }

    /**
     * 修改鈑烤工單
     * @param {*} ppo_id 鈑烤工單流水號
     * @param {*} pppl_id 金額等級流水號
     * @param {*} predict_complete_time 預計完工時間
     * @param {*} note 備註
     * @returns 
     */
    const PanelPaintOrderUpdate = async function (obj = {
        ppo_id: '',
        pppl_id: '',
        predict_complete_time: '',
        note: ''
    }) {
        return await allFetch('PanelPaintOrder/PanelPaintOrderUpdate', obj);
    }
    

    /**
     * 查詢鈑烤工單
     * @param {*} wom_id 工單流水號
     * @param {*} wom_code 工單號碼
     * @param {*} user_id 使用者流水號
     * @param {*} position_id 據點流水號
     * @param {*} car_id 車流水號
     * @param {*} license_plate 車牌號碼
     * @param {*} time_enter_start 進廠時間起
     * @param {*} time_enter_end 進廠時間迄
     * @param {*} time_leave_start 離廠時間起
     * @param {*} time_leave_end 離廠時間迄
     * @param {*} is_complete 是否完工
     * @param {*} complete_time_start 完工時間起
     * @param {*} complete_time_end 完工時間迄
     * @param {*} is_invalid 是否作廢
     * @param {*} invalid_time_start 作廢時間起
     * @param {*} invalid_time_end 作廢時間迄
     * @param {*} is_dispatch 是否派工
     * @param {*} dispatch_time_start 派工時間起
     * @param {*} dispatch_time_end 派工時間迄
     * @param {*} pppl_id 金額等級流水號
     * @param {*} ppsl_big 狀態大標籤流水號
     * @param {*} ppsl_mid 狀態中標籤流水號
     * @param {*} ppsl_small 狀態小標籤流水號
     * @param {*} predict_complete_time_start 預計完工時間起
     * @param {*} predict_complete_time_end 預計完工時間迄
     * @param {*} sort_name 排序 <進廠時間|完工時間>
     * @param {*} sort_order 正倒序 <正|倒>
     * @param {*} page 頁碼
     * @param {*} num_per_page 一頁幾筆
     * @returns 
     */
    const PanelPaintOrderSearch = async function (obj = {
        wom_id: '',
        wom_code: '',
        user_id: '',
        position_id: '',
        car_id: '',
        license_plate: '',
        time_enter_start: '',
        time_enter_end: '',
        time_leave_start: '',
        time_leave_end: '',
        is_complete: '',
        complete_time_start: '',
        complete_time_end: '',
        is_invalid: '',
        invalid_time_start: '',
        invalid_time_end: '',
        is_dispatch: '',
        dispatch_time_start: '',
        dispatch_time_end: '',
        pppl_id: '',
        ppsl_big: '',
        ppsl_mid: '',
        ppsl_small: '',
        predict_complete_time_start: '',
        predict_complete_time_end: '',
        sort_name: "", //進廠時間、完工時間
        sort_order: "", // 正、倒
        page: '',
        num_per_page: ''
    }) {
        return await allFetch('PanelPaintOrder/PanelPaintOrderSearch', obj);
    }

    /**
     * 鈑烤工單細項
     * @param {*} ppo_id 鈑烤工單流水號
     * @returns 
     */
    const PanelPaintOrderDetail = async function (obj = {
        ppo_id: ''
    }) {
        return await allFetch('PanelPaintOrder/PanelPaintOrderDetail', obj);
    }

    /**
     * 鈑烤工單派工
     * @param {*} ppo_id 鈑烤工單流水號
     * @returns 
     */
    const PanelPaintOrderDispatch = async function (obj = {
        ppo_id: ''
    }) {
        return await allFetch('PanelPaintOrder/PanelPaintOrderDispatch', obj);
    }

    /**
     * 鈑烤工單完工
     * @param {*} ppo_id 鈑烤工單流水號
     * @returns 
     */
    const PanelPaintOrderComplete = async function (obj = {
        ppo_id: ''
    }) {
        return await allFetch('PanelPaintOrder/PanelPaintOrderComplete', obj);
    }

    /**
     * 鈑烤工單作廢
     * @param {*} ppo_id 鈑烤工單流水號
     * @returns 
     */
    const PanelPaintOrderInvalid = async function (obj = {
        ppo_id: ''
    }) {
        return await allFetch('PanelPaintOrder/PanelPaintOrderInvalid', obj);
    }

    /**
     * 新增鈑烤工單狀態異動記錄
     * @param {*} ppo_id 鈑烤工單流水號
     * @param {*} ppsl_big 狀態大標籤流水號
     * @param {*} ppsl_mid 狀態中標籤流水號
     * @param {*} ppsl_small 狀態小標籤流水號
     * @returns 
     */
    const PanelPaintOrderStatusLogCreate = async function (obj = {
        ppo_id: '',
        ppsl_big: '',
        ppsl_mid: '',
        ppsl_small: '',
    }) {
        return await allFetch('PanelPaintOrder/PanelPaintOrderStatusLogCreate', obj);
    }

    /**
     * 新增鈑烤工單狀態異動記錄
     * @param {*} ppo_id 鈑烤工單流水號
     * @returns 
     */
    const PanelPaintOrderStatusLogSearch = async function (obj = {
        ppo_id: ''
    }) {
        return await allFetch('PanelPaintOrder/PanelPaintOrderStatusLogSearch', obj);
    }

    /** 新增延遲完工紀錄 */
    const PanelPaintOrderDelayLogCreate = async function (obj = {
        ppo_id: '',
        delay_complete_time: '',
        note: '',
        operation_user_id: ''
    }) {
        return await allFetch('PanelPaintOrder/PanelPaintOrderDelayLogCreate', obj);
    }

    /** 查詢延遲完工紀錄 */
    const PanelPaintOrderDelayLogSearch = async function (obj = {
        ppo_id: ''
    }) {
        return await allFetch('PanelPaintOrder/PanelPaintOrderDelayLogSearch', obj);
    }


    return {
        PanelPaintOrderCreate,
        PanelPaintOrderUpdate,
        PanelPaintOrderSearch,
        PanelPaintOrderDetail,
        PanelPaintOrderDispatch,
        PanelPaintOrderComplete,
        PanelPaintOrderInvalid,
        PanelPaintOrderStatusLogCreate,
        PanelPaintOrderStatusLogSearch,
        PanelPaintOrderDelayLogCreate,
        PanelPaintOrderDelayLogSearch
    }
})();